import { render, staticRenderFns } from "./AddRealEstate.vue?vue&type=template&id=0dec9d76&"
import script from "./AddRealEstate.vue?vue&type=script&lang=js&"
export * from "./AddRealEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports